import React from "react";

const PrivacyPolicyText = () => {
  return (
    <>
      <h1 className="mb-10 text-4xl font-semibold text-black">
        Privacy Policy
      </h1>
      <small className="mb-5 block text-base font-normal">
        Last updated: 2 September 2021
      </small>
      <p className="mb-4">
        In this Privacy Policy, ‘us’ ‘we’ or ‘our’ means Tracer DAO. We are
        committed to respecting your privacy. Our Privacy Policy sets out how we
        collect, use, store and disclose your personal information.
      </p>
      <p className="mb-4">
        This Privacy Policy applies to our services, which include the services
        we provide on https://tracer.finance/ or any other websites, pages,
        features, or content we own or operate or when you use related services.
        If you do not agree with the terms of this Privacy Policy, do not access
        or use the services, websites, or any other aspect of our business.
      </p>
      <p className="mb-4">
        By providing personal information to us, you consent to our collection,
        use and disclosure of your personal information in accordance with this
        Privacy Policy and any other arrangements that apply between us. We may
        change our Privacy Policy from time to time by publishing changes to it
        on our website. We encourage you to check our website periodically to
        ensure that you are aware of our current Privacy Policy.
      </p>
      <p className="mb-4">
        Personal information includes information or an opinion about an
        individual that is reasonably identifiable.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        How do we collect personal information?
      </h2>
      <p className="mb-4">
        We may collect these types of personal information either directly from
        you, or from third parties. We may collect this information when you:
      </p>
      <ul className="mb-4 list-outside list-disc pl-4">
        <li>register on our website or app;</li>
        <li>
          communicate with us through correspondence, chats, email, or when you
          share information with us from other social applications, services or
          websites; or
        </li>
        <li>interact with our sites, services, content and advertising.</li>
      </ul>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Why do we collect, use and disclose personal information?
      </h2>
      <p className="mb-4">
        We may collect, hold, use and disclose your personal information for the
        following purposes:
      </p>
      <ul className="mb-4 list-outside list-disc pl-4">
        <li>to enable you to access and use our website, services and app;</li>

        <li>
          to operate, protect, improve and optimise our website, services and
          app, business and our users’ experience, such as to perform analytics,
          conduct research and for advertising and marketing;
        </li>
        <li>
          to send you service, support and administrative messages, reminders,
          technical notices, updates, security alerts, and information requested
          by you;
        </li>

        <li>
          to send you marketing and promotional messages and other information
          that may be of interest to you, including information sent by, or on
          behalf of, our business partners that we think you may find
          interesting;
        </li>
        <li>
          to administer rewards, surveys, contests, or other promotional
          activities or events sponsored or managed by us or our business
          partners;
        </li>
        <li>
          to comply with our legal obligations, resolve any disputes that we may
          have with any of our users, and enforce our agreements with third
          parties; and to consider your employment application.
        </li>
      </ul>
      <p className="mb-4">
        We may also disclose your personal information to a trusted third party
        who also holds other information about you. This third party may combine
        that information in order to enable it and us to develop anonymised
        consumer insights so that we can better understand your preferences and
        interests, personalise your experience and enhance the products and
        services that you receive.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Using our website and cookies
      </h2>
      <p className="mb-4">
        We may collect personal information about you when you use and access
        our website.
        <br /> While we do not use browsing information to identify you
        personally, we may record certain information about your use of our
        website, such as which pages you visit, the time and date of your visit
        and the internet protocol address assigned to your computer.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Integrated third party services
      </h2>
      <p className="mb-4">
        Various third party services are integrated with our website, including
        MetaMask. Unless expressly stated otherwise, we are not responsible for
        the privacy practices of integrated third party services, and have no
        control over or rights in those linked services. The privacy policies
        that apply to integrated third party services may differ substantially
        from our Privacy Policy, so we encourage individuals to read them before
        using those services.
      </p>

      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Accessing or correcting your personal information
      </h2>
      <p className="mb-4">
        You can access the personal information we hold about you by contacting
        us at&nbsp;
        <a href="mailto:hello@tracer.finance">hello@tracer.finance</a>.
        Sometimes, we may not be able to provide you with access to all of your
        personal information and, where this is the case, we will tell you why.
        We may also need to verify your identity when you request your personal
        information. If you think that any personal information we hold about
        you is inaccurate, please contact us and we will take reasonable steps
        to ensure that it is corrected.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">Contact Us</h2>
      <p className="mb-4">
        For further information about our Privacy Policy or practices, or to
        access or correct your personal information, or make a complaint, please
        contact us at&nbsp;
        <a href="mailto:hello@tracer.finance">hello@tracer.finance</a>.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        What personal information do we collect?
      </h2>
      <p className="mb-4">
        For further information about our Privacy Policy or practices, or to
        access or correct your personal information, or make a complaint, please
        contact us at&nbsp;
        <a href="mailto:hello@tracer.finance">hello@tracer.finance</a>.
      </p>
      <p className="mb-4">
        We may collect the following types of personal information:
      </p>
      <ul className="mb-4 list-outside list-disc pl-4">
        <li>contact information, such as your email address;</li>
        <li>
          transactional information, such as information about the transactions
          you make on our services, such as the type, time or amount of a
          transaction;
        </li>
        <li>
          correspondence, such as your feedback or questionnaire and other
          survey responses;
        </li>
        <li>
          online identifiers, such as your blockchain address, device ID, device
          type, geo-location information, computer and connection information,
          statistics on page views, traffic to and from the sites, ad data, IP
          address and standard web log information;
        </li>

        <li>
          usage data, such as user preferences and other data collected via
          cookies and similar technologies;
        </li>

        <li>
          details of the products and services we have provided to you or that
          you have enquired about, including any additional information
          necessary to deliver those products and services and respond to your
          enquiries;
        </li>

        <li>
          any additional information relating to you that you provide to us
          directly through our website or app or indirectly through your use of
          our website or app or online presence or through other websites or
          accounts from which you permit us to collect information; or
        </li>

        <li>
          any other personal information that may be required in order to
          facilitate your dealings with us.
        </li>
      </ul>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Do we use your personal information for direct marketing?
      </h2>
      <p className="mb-4">
        We and/or our carefully selected business partners may send you direct
        marketing communications and information about our service and products.
        This may take the form of emails, Discord messages, or other forms of
        communication, in accordance with the OECD Guidelines on the Protection
        of Privacy and Transborder Flows of Personal Data. You may opt-out of
        receiving marketing materials from us by contacting us using the details
        set out below or by using the opt-out facilities provided (eg an
        unsubscribe link).
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        To whom do we disclose your personal information?
      </h2>
      <p className="mb-4">
        We may disclose personal information for the purposes described in this
        privacy policy to:
      </p>
      <ul className="mb-4 list-outside list-disc pl-4">
        <li>
          third party suppliers and service providers (including providers for
          the operation of our websites and/or our business or in connection
          with providing our products and services to you);
        </li>
        <li>
          our existing or potential agents, business partners or partners;
        </li>
        <li>
          our sponsors or promoters of any competition that we conduct via our
          services;
        </li>
        <li>
          anyone to whom our assets or businesses (or any part of them) are
          transferred;
        </li>
        <li>
          specific third parties authorised by you to receive information held
          by us; and/or
        </li>
        <li>
          other persons, including government agencies, regulatory bodies and
          law enforcement agencies, or as required, authorised or permitted by
          law.
        </li>
      </ul>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Disclosure of personal information
      </h2>
      <p className="mb-4">
        When you provide your personal information to us, you consent to the
        disclosure of your information globally which may include countries in
        the following jurisdictions: United States of America, British Virgin
        Islands, United Kingdom and Europe. We will, however, take reasonable
        steps to ensure that any overseas recipient will deal with such personal
        information in a way that is consistent with the OECD Guidelines on the
        Protection of Privacy and Transborder Flows of Personal Data.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">Security</h2>
      <p className="mb-4">
        We may hold your personal information in either electronic or hard copy
        form. We take reasonable steps to protect your personal information from
        misuse, interference and loss, as well as unauthorised access,
        modification or disclosure and we use a number of physical,
        administrative, personnel and technical measures to protect your
        personal information. However, we cannot guarantee the security of your
        personal information.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">Links</h2>
      <p className="mb-4">
        Our website may contain links to websites operated by third parties.
        Those links are provided for convenience and may not remain current or
        be maintained. Unless expressly stated otherwise, we are not responsible
        for the privacy practices of, or any content on, those linked websites,
        and have no control over or rights in those linked websites. The privacy
        policies that apply to those other websites may differ substantially
        from our Privacy Policy, so we encourage individuals to read them before
        using those websites.
      </p>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">
        Making a complaint
      </h2>
      <p className="mb-4">
        If you think we have breached the OECD Guidelines on the Protection of
        Privacy and Transborder Flows of Personal Data, or you wish to make a
        complaint about the way we have handled your personal information, you
        can contact us at&nbsp;
        <a href="mailto:hello@tracer.finance">hello@tracer.finance</a>. Please
        include your name or Discord username and clearly describe your
        complaint. We will acknowledge your complaint and respond to you
        regarding your complaint within a reasonable period of time. If you
        think that we have failed to resolve the complaint satisfactorily, we
        will provide you with information about the further steps you can take.
      </p>
      <ol className="list-inside list-alpha">
        <li>
          the Office of the Australian Information Commissioner by
          visiting&nbsp;
          <a href="https://www.oaic.gov.au" target="_blank">
            www.oaic.gov.au
          </a>
          , emailing&nbsp;
          <a href="mailto:enquiries@oaic.gov.au">enquiries@oaic.gov.au;</a>
        </li>
        <li>writing to GPO Box 5218 Sydney NSW 2001; or </li>
        <li>contacting the Privacy Commissioner in your State or Territory.</li>
      </ol>
      <h2 className="mb-4 mt-8 text-xl font-semibold text-black">Effective</h2>
      <p className="mb-4">17 June 2022</p>
    </>
  );
};

export default PrivacyPolicyText;
